PJQ.views.timecards.TimeCardMain = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'timecard'),
        isShowHeader: true,
        project: null,
        contact: null,
        useManualDateRange: false
    },
    events: {
        'click .btn-settings': 'settings',
        'keyup .input-search': 'searchChanged',
        'click .search': 'search',
        'click .clear-search': 'clearFilter',
        'click .new-timecards': 'addTimeCards',
        'click .approve-batch': 'approveBatchStart',
        'click .unapprove-batch': 'approveBatchStart',
        'click .approval-continue': 'approveBatchContinue',
        'click .cancel-approval': 'approveBatchCancel',
        'click .export': 'exportList',
        'click .export-weekly': 'exportWeekly',
        'click .btn-manual-range': 'manualDateRange',
        'click .btn-auto-range': 'autoDateRange',
        'click .btn-prev-date': 'prevDateRange',
        'click .btn-next-date': 'nextDateRange'
    },
    beforeFirstRender: function () {
        this.selectedTimeCards = [];
        this.selectionMode = PJQ.constants.timecards.selectionMode.NONE;

        if (this.options.project != null) {
            this.options.permissions = PJQ.app.session.project.permissions;
        } else {
            this.options.permissions = PJQ.app.session.systemPermissions;
        }

        this.isFetched = false;
        this.userSettings = new PJQ.models.timecards.TimeCardUserSettings();
        this.userSettings.fetch({
            success: _.bind(function () {
                this.settings = new PJQ.models.timecards.TimeCardSettings(null, {
                    contact: this.options.contact,
                    project: this.options.project
                });
                this.settings.fetch({
                    success: _.bind(function () {
                        this.isFetched = true;
                        this.currentView = this.userSettings.get('defaultView');
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    beforeRender: function () {
        if (this.isFetched) {
            this.options.canAdd = this.options.permissions.hasPermission('timeCards.canAdd');
            this.options.canApprove = this.options.permissions.hasPermission('timeCards.canApprove');
            this.options.canViewAll = this.options.permissions.hasPermission('timeCards.canViewAll');
            this.options.isAdmin = this.options.permissions.hasPermission('timeCards.isAdmin');
        }
    },
    renderData: function () {
        return {
            showHeader: this.options.isShowHeader,
            project: this.options.project,
            contact: this.options.contact,
            useManualDateRange: this.options.useManualDateRange,
            canAdd: this.options.canAdd,
            canApprove: this.options.canApprove,
            canViewAll: this.options.canViewAll,
            isAdmin: this.options.isAdmin,
            isFetched: this.options.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.viewSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.timecards-view'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: this.options.project ? PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD : this.userSettings.get('defaultView'),
            onHide: _.bind(function () {
                if (this.currentView !== this.viewSelectPicker.getValue())
                    this.renderView();
            }, this)
        });

        this.renderView();

        this.renderTotals();
    },
    renderTotals: function () {
        if (this.options.project == null || !this.options.isAdmin) {
            return;
        }

        this.options.project.fetchBudgetTimeStats((stats) => {
            let $totals = this.$('.timecard-totals');
            if (!stats) {
                $totals.empty();
                return;
            }

            $totals.html(`
                <div class="card p-2 wd-150p mr-3 ml-3 elevation-1 text-align-center text-dark">
                    <div class="fs-16 font-weight-light lh-20">
                        Budgeted Hours
                    </div>
                    <div class="total-projected fs-18 font-weight-medium lh-20">
                        ${PJQ.helpers.formatHelpers.minutesToHHMM(stats.budgetedHours)}
                    </div>
                </div>
                <div class="card p-2 wd-150p mr-3 ml-3 elevation-1 text-align-center text-dark">
                    <div class="fs-16 font-weight-light lh-20">
                        Actual Hours
                    </div>
                    <div class="fs-18 font-weight-medium lh-20">
                        ${PJQ.helpers.formatHelpers.minutesToHHMM(stats.actualHours)}
                    </div>
                </div>`
            );
        });
    },
    manualDateRange: function () {
        this.options.useManualDateRange = true;
        this.render();
    },
    autoDateRange: function () {
        this.options.useManualDateRange = false;
        this.render();
    },
    renderDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        if (!this.options.useManualDateRange) {
            switch (dateRange) {
                case PJQ.constants.timecards.defaultDateRange.DAYS_30:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                    }
                    this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 29);
                    break;
                case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                        switch (this.settings.get('weekStart')) {
                            case 0: // Su
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                                break;
                            default:
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.settings.get('weekStart'))) % 7);
                                break;
                        }

                        this.endDate = new Date();
                    } else {
                        this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 6);
                    }
                    break;
                case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                    if (this.startDate == null) {
                        this.startDate = PJQ.helpers.dateHelpers.parseDateString(PJQ.helpers.dateHelpers.getCurrentYear() + '-' + PJQ.helpers.dateHelpers.getCurrentMonth() + '-01 00:00:00');
                        this.endDate = new Date();
                    } else {
                        this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 29);
                    }
                    break;
                default:
                    if (this.startDate == null) {
                        this.startDate = new Date();
                        switch (this.settings.get('weekStart')) {
                            case 0: // Su
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay()) % 7);
                                break;
                            default:
                                this.startDate.setDate(this.startDate.getDate() - (this.startDate.getDay() + (7 - this.settings.get('weekStart'))) % 7);
                                break;
                        }
                    }

                    this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange - 1);
                    break;
            }
        } else if (this.startDate == null) {
            this.startDate = new Date();
            this.endDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange - 1);
        }

        if (this.options.useManualDateRange) {
            if (this.startDatePicker) {
                this.startDatePicker.remove();
            }
            if (this.endDatePicker) {
                this.endDatePicker.remove();
            }

            this.startDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.start-date'),
                datepickerOptions: {
                    defaultDate: this.startDate,
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                },
                onChange: _.bind(function (value) {
                    this.selectedTimeCards = [];
                    this.startDate = value;
                    this.renderView();
                }, this)
            });

            this.endDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.end-date'),
                datepickerOptions: {
                    defaultDate: this.endDate,
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                },
                onChange: _.bind(function (value) {
                    this.selectedTimeCards = [];
                    this.endDate = value;
                    this.renderView();
                }, this)
            });
        } else {
            let startDateString = PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE),
                endDateString = PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
            this.$('.date-range-display').text(startDateString + ' - ' + endDateString);
        }
    },
    prevDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        switch (dateRange) {
            case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -7);
                break;
            case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -30);
                break;
            default:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, -dateRange);
                break;
        }
        this.renderView();
    },
    nextDateRange: function () {
        let dateRange = this.userSettings.get('defaultDateRange');
        switch (dateRange) {
            case PJQ.constants.timecards.defaultDateRange.WEEK_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 7);
                break;
            case PJQ.constants.timecards.defaultDateRange.MONTH_TO_DATE:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, 30);
                break;
            default:
                this.startDate = PJQ.helpers.dateHelpers.getNewDateAddDays(this.startDate, dateRange);
                break;
        }
        this.renderView();
    },
    renderView: function (view, options = {}) {
        this.currentView = view ? view : this.viewSelectPicker.getValue();

        this.renderDateRange();

        PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), true);
        if (this.startDate > this.endDate) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.start-date, .end-date'), false);
            return;
        }

        let page = null;
        if (options.stayOnPage && this.dataTable != null) {
            page = this.dataTable.dataTable.page();
        }


        if (this.dataTable) {
            this.dataTable.cleanup();
            this.dataTable.clearServerCache = true;
            this.dataTable.pageCache = [];
            this.dataTable.remove();
            this.dataTable = null;
            this.$('.timecards-data').empty();
        }

        let tableSettings = this.userSettings.getSettings(this.currentView),
            dataTableOptions = {
                el: this.$('.timecards-data'),
                language: {
                    zeroRecords: 'No Results Available'
                },
                data: null,
                project: this.options.project,
                view: this.currentView,
                timecardsView: this,
                timeCardSettings: this.settings,
                settings: tableSettings,
                userSettings: this.userSettings,
                getPageCallback: _.bind(this.getViewData, this),
                displayStart: page != null ? page * tableSettings.rowsPerPage : null,
                deferRender: true,
                clearServerCache: true,
                showPageSelector: true,
                onChange: () => {
                    this.renderTotals();
                },
                onApprove: (timecards, approve, callback) => {
                    if (timecards == null) {
                        return;
                    }

                    let ids;
                    if (PJQ.helpers.objectHelpers.refinedType(timecards) === 'array') {
                        ids = _.map(_.filter(timecards, (tc) => {
                            return approve ? tc.get('approvedOn') == null : tc.get('approvedOn') != null;
                        }), (tc) => {
                            return tc.id;
                        });
                    } else if (timecards.id != null) {
                        ids = [timecards.id];
                    }

                    let tcCount = _.size(ids);
                    if (tcCount > 0) {
                        this.approveTimeCards(ids, approve, (response) => {
                            PJQ.notifications.notify.successNotify({
                                message: tcCount.toString() + ' Time Cards successfully ' + (approve ? 'approved' : 'unapproved')
                            });
                            if (typeof callback === 'function') {
                                callback(response);
                            }
                        });
                    }
                },
                onTableDraw: (dataTable) => {
                    this.$('.timecards-data').css('margin-top', -40);
                },
                colReorder: {
                    fixedColumnsLeft: 1,
                    fixedColumnsRight: (this.currentView === PJQ.constants.timecards.view.BY_TIMECARD || this.currentView === PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD) ? 1 : 0,
                    realtime: false
                }
            };

        this.dataTable = this.getDataTableInstance(dataTableOptions);
    },
    getViewData: function (pageNumber, pageSize, orderArr, callback) {
        let order = orderArr[0];
        this.data = null;

        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.data = new PJQ.collections.timecards.TimeCards();
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
                this.data = new PJQ.collections.timecards.TimeCardProjects();
                break;
            case PJQ.constants.timecards.view.BY_CONTACT:
                this.data = new PJQ.collections.timecards.TimeCardContacts();
                break;
        }

        let idFilter = 0;
        if (this.options.contact)
            idFilter = this.options.contact.id;
        else {
            if ((PJQ.app.session.systemPermissions == null || !PJQ.app.session.systemPermissions.hasPermission('contacts.canView')) && (PJQ.app.session.project === null || this.options.permissions.hasPermission('canViewAll')))
                idFilter = -PJQ.app.session.user.id;
        }
        let dateNow = new Date(),
            parameters = {
                searchFor: this.$('.input-search').val(),
                startDate: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                endDate: PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD),
                page: pageNumber,
                pageSize: pageSize,
                orderBy: order.name,
                orderDirection: order.direction,
                timeZoneOffset: dateNow.getTimezoneOffset(),
                projectId: this.options.project ? this.options.project.get('projectId') : 0,
                idFilter: idFilter
            };

        this.data.fetch({
            data: parameters,
            success: _.bind(function () {
                callback(this.data.models, this.data.totalRows);
            }, this),
            fail: _.bind(function () {
                callback();
            }, this)
        });
    },
    getDataTableInstance: function (options) {
        let dataTable = null;

        switch (options.view) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
                dataTable = new PJQ.views.timecards.ProjectDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT_CONTACT:
                dataTable = new PJQ.views.timecards.ContactDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT:
                dataTable = new PJQ.views.timecards.ContactDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT_PROJECT:
                dataTable = new PJQ.views.timecards.ProjectDataTable(options);
                break;
            case PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD:
                dataTable = new PJQ.views.timecards.TimeCardDataTable(options);
                break;
        }
        return dataTable;
    },
    searchChanged: function (e) {
        if (e.keyCode === 13) {
            this.selectedTimeCards = [];
            this.search();
        }
    },
    search: function () {
        this.renderView();
    },
    clearFilter: function () {
        this.$('.input-search').val('');
        this.renderView();
    },
    settings: function () {
        new PJQ.views.timecards.TimeCardSettingsModal({
            timecardsView: this,
            onSave: _.bind(function () {
                this.startDate = null;
                this.endDate = null;
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    addTimeCards: function () {
        if (!this.options.canAdd) {
            return;
        }

        if (this.settings.get('enableLineItems') || this.settings.get('enableClockIn')) {
            new PJQ.views.timecards.AddTimeCardsModal({
                project: this.options.project,
                settings: this.settings,
                onSave: () => {
                    this.renderView(this.currentView, {stayOnPage: true});
                    this.renderTotals();
                }
            });
        } else {
            new PJQ.views.timecards.ManageTimeCardsByWeekModal({
                timecardsView: this,
                settings: this.settings,
                project: this.options.project,
                contact: this.options.contact,
                onSave: () => {
                    this.renderView(this.currentView, {stayOnPage: true});
                    this.renderTotals();
                }
            });
        }
    },
    approveBatchStart: function (e) {
        this.selectionMode = $(e.currentTarget).hasClass('approve-batch') ? PJQ.constants.timecards.selectionMode.APPROVE : PJQ.constants.timecards.selectionMode.UNAPPROVE;
        this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.renderView(null, {stayOnPage: true});
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
            case PJQ.constants.timecards.view.BY_CONTACT:
                _.each(this.dataTable.options.childDataTables, _.bind(function (childDT) {
                    _.each(childDT.options.childDataTables, _.bind(function (grandChildDT) {
                        childDT.renderChildRow(childDT.getRow(grandChildDT.$el.closest('tr').prev()), grandChildDT.options.parentId);
                    }, this));
                }, this));
                break;
        }

        this.showNotification('Select 1 or more Time Cards and click "' + (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE ? 'Approve' : 'Un-Approve') + ' Checked" to continue.', 'info');
        this.$('.approval-continue').text((this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE ? 'Approve' : 'Un-Approve') + ' Checked');
        this.$('.new-timecards, .other-actions').prop('disabled', true);
        this.$('.approval-continue, .cancel-approval').show();
    },
    approveBatchCancel: function () {
        this.selectionMode = PJQ.constants.timecards.selectionMode.NONE;
        this.selectedTimeCards = [];

        switch (this.currentView) {
            case PJQ.constants.timecards.view.PROJECTWALL_BY_TIMECARD:
            case PJQ.constants.timecards.view.BY_TIMECARD:
                this.renderView(null, {stayOnPage: true});
                break;
            case PJQ.constants.timecards.view.BY_PROJECT:
            case PJQ.constants.timecards.view.BY_CONTACT:
                _.each(this.dataTable.options.childDataTables, _.bind(function (childDT) {
                    _.each(childDT.options.childDataTables, _.bind(function (grandChildDT) {
                        childDT.renderChildRow(childDT.getRow(grandChildDT.$el.closest('tr').prev()), grandChildDT.options.parentId);
                    }, this));
                }, this));
                break;
        }

        this.$('.new-timecards, .other-actions').prop('disabled', false);
        this.$('.approval-continue, .cancel-approval').hide();
        this.hideNotification();
    },
    approveBatchContinue: function () {
        let isApproved = (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE);
        new PJQ.views.modals.YesNo({
            header: "Confirm " + (isApproved ? 'Approval' : 'Un-Approval'),
            body: "Are you sure you want to " + (isApproved ? 'approve' : 'un-approve') + " " + _.size(this.selectedTimeCards) + " Time Card" + (_.size(this.selectedTimeCards) > 1 ? "s" : "") + "?",
            onYes: _.bind(function () {
                this.approveTimeCards(this.selectedTimeCards, isApproved, _.bind(function () {
                    let plural = _.size(this.selectedTimeCards) > 0 ? 's' : '';
                    this.approveBatchCancel();
                    PJQ.notifications.notify.successNotify({
                        message: 'Time Card' + plural + ' ' + (isApproved ? 'approved' : 'unapproved')
                    });
                }, this));
            }, this)
        });
    },
    approveTimeCards: function (timeCardIds, isApproved, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'timecards',
                },
                {
                    endpoint: 'batch',
                },
                {
                    endpoint: 'approve'
                }
            ]),
            data: {
                timeCardIds: timeCardIds,
                isApproved: isApproved
            },
            isAPIv2: true
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(response);
            }
        }, this));
    },
    addSelectedTimeCards: function (timeCardIds) {
        this.selectedTimeCards = _.uniq(_.union(timeCardIds, this.selectedTimeCards));

        if (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE || this.selectionMode === PJQ.constants.timecards.selectionMode.UNAPPROVE)
            this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
    },
    removeSelectedTimeCards: function (timeCardIds) {
        this.selectedTimeCards = _.without(this.selectedTimeCards, ...timeCardIds);

        if (this.selectionMode === PJQ.constants.timecards.selectionMode.APPROVE || this.selectionMode === PJQ.constants.timecards.selectionMode.UNAPPROVE)
            this.$('.approval-continue').prop('disabled', _.size(this.selectedTimeCards) === 0);
    },
    hideNotification: function () {
        this.$('.timecard-notifications').hide();
    },
    showNotification: function (content, type) {
        this.$('.timecard-notifications').removeClass('alert-primary').removeClass('alert-secondary').removeClass('alert-info').removeClass('alert-success').removeClass('alert-warning').removeClass('alert-danger');
        this.$('.timecard-notifications').addClass('alert-' + type);

        let icon = '';
        switch (type) {
            case 'info':
                icon = '<i class="fas fa-info-circle fa-xs"></i>';
                break;
        }

        this.$('.timecard-notifications').html(icon + (icon ? ' ' : '') + content);
        this.$('.timecard-notifications').show();
    },
    export: function (view) {
        let parameters = [
            {
                parameter: 'searchFor',
                value: this.$('.input-search').val()
            },
            {
                parameter: 'startDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'endDate',
                value: PJQ.helpers.dateHelpers.getDateString(this.endDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD)
            },
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            },
            {
                parameter: 'projectId',
                value: this.options.project ? this.options.project.get('projectId') : 0
            },
            {
                parameter: 'idFilter',
                value: this.options.contact ? this.options.contact.id : 0
            },
            {
                parameter: 'view',
                value: view
            }
        ];

        let downloadEndpoint = [
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'export'
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint(downloadEndpoint, parameters), {isAPIv2: true});
    },
    exportList: function () {
        this.export('timecard-list');
    },
    exportWeekly: function () {
        let template = 'timecard-weekly';
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.TIMECARD_WEEKLY_EXPORT_TEMPLATE))
            template = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.TIMECARD_WEEKLY_EXPORT_TEMPLATE);
        this.export(template);
    }
});